/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { APPLICATION_VIEW_OFFICE } from '@gh/builder-shared-data';

import { createRoute } from '@gh/builder-shared';

import { CashFlowForecastDetailsComponent } from './cash-flow-forecast/components/cash-flow-forecast-details/cash-flow-forecast-details.component';
import { CashFlowForecastDetailsBusinessService } from './cash-flow-forecast/resources/cash-flow-forecast-details-business.service';
import { EomReportBusinessService, EomReportDetailsComponent } from './eom-reports';
import { FranchiseReportFilterComponent } from './franchise-monthly-report/components/franchise-report-filter/franchise-report-filter.component';
import { FranchiseMonthlyReportBusinessService } from './franchise-monthly-report/resources/franchise-monthly-report-business.service';
import { JobRedoEstimateComponent } from './job-redo/components/job-redo-estimate/job-redo-estimate.component';
import { WipDetailsComponent } from './wip/components/wip-details/wip-details.component';
import { WipBusinessService } from './wip/resources/wip-business.service';
import { CareerEnquiriesListComponent } from './career-enquiries/components/career-enquiries-list/career-enquiries-list.component';
import { CareerEnquiriesBusinessService } from './career-enquiries/resource/career-enquiries-business.service';

export const routes: Routes = [
  createRoute({
    path: 'job-redo',
    component: JobRedoEstimateComponent,
    leave: true,
    auth: {
      permission: 'Estimating.JobEstimate.REDO',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'cash-flow-forecast',
    component: CashFlowForecastDetailsComponent,
    init: CashFlowForecastDetailsBusinessService,
    leave: true,
    auth: {
      permission: 'Manager.CashFlowForecast.MANAGE',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'wip',
    component: WipDetailsComponent,
    init: WipBusinessService,
    leave: true,
    auth: {
      permission: 'Manager.WipProfitAdj.MANAGE',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'franchise',
    component: FranchiseReportFilterComponent,
    init: FranchiseMonthlyReportBusinessService,
    leave: true,
    auth: {
      permission: 'Manager.FranchiseMonthly.MANAGE',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'eom-reports',
    component: EomReportDetailsComponent,
    init: EomReportBusinessService,
    leave: true,
    auth: {
      permission: 'Manager.EomReports.MANAGE',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'career-enquiries',
    component: CareerEnquiriesListComponent,
    init: CareerEnquiriesBusinessService,
    auth: {
      permission: 'Manager.CareerEnquiries.LIST',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  declarations: [],
  exports: [RouterModule],
})
export class BuilderManagerRoutingModule {
}
